export default "__VITE_ASSET__e4d29b12__"